<template>
  <v-container fluid>
    <GanttDiagram
      class="mt-6"
      :events="dashboard.timeline"
    />
  </v-container>
</template>

<script>
import { GanttDiagram } from "@/components"
import ProjectService from "@/services/ProjectService"

export default {
  components: { GanttDiagram },
  name: "ProjectGantt",
  data() {
    return {
      dashboard: {
        completion_percent: 0,
        created_at: "",
        description: "",
        inspector: null,
        non_conformities_kpi: 0,
        role: "",
        tasks_kpi: 0,
        team: [],
        timeline: []
      },
      loading: true
    }
  },
  created() {
    this.init()
  },
  computed: {
    hasTimelineEvents() {
      return this.dashboard.timeline.length > 0
    },
    project() {
      return this.$store.state.app.project
    }
  },
  methods: {
    init() {
      this.loading = true
      ProjectService.get_gantt_data(this, this.project.id)
        .then(r => {
          this.dashboard = r
          this.dashboard.role = this.project.role
        })
        .catch(err => {
          if (err.response && err.response.status === 403) {
            // alert("Access denied: You do not have permission to access this resource.")
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error"
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    "$store.state.app.project": function () {
      this.init()
    }
  }
}
</script>
